import request from '@/utils/zsm-requets'
const douyinQualification = '/zsm/api/douyin/qualification/'
const quanlification = '/zsm/api/quanlification/'
/**
 * 上传资质
 *
          firstClass: '', //一级分类
          secondClass: '', //二级分类
          thirdClass: '', //三级分类
          idImgUris: '', //身份证图片
          idNumber: '', //身份证号
          name: '', //姓名
          objectType: 1, //类型 1讲师 2企业
          firstClass: '', //一级分类
 */
export function saveQualification(info) {
  return request({
    url: douyinQualification + 'save',
    method: 'post',
    params: info
  })
}

// 获取资质列表
export function listDataQualification(info) {
  return request({
    url: douyinQualification + 'listData',
    method: 'post',
    params: info
  })
}

/*
上传某人的身份证正反面
 idNumber	编号
 mobile	手机号
 negativeUrl 反面地址
 positiveUrl  正面地址
 title	姓名

 */
// export function createIdCard(info) {
//   return request({
//     url: quanlification+'createIdCard',
//     method: 'post',
//     params: info
//   })
// }

/*
上传某人的资质证书
bizDict	类型
classifyOne	一级分类
classifyThree	三级分类
classifyTwo	二级分类
idNumber  身份证号/或者营业执照
imageUrls 照片列表
mobile  手机号
title 资质名称/姓名
validDate 有效期
 */
// export function createQualification(info) {
//   return request({
//     url: quanlification+'createQualification',
//     method: 'post',
//     params: info
//   })
// }

/*
查看证书
bizDict	类型
classifyOne	一级分类
classifyThree	三级分类
classifyTwo	二级分类
idNumber  身份证号/或者营业执照
imageUrls 照片列表
mobile  手机号
title 资质名称/姓名
validDate 有效期
 */
/* export function listDataQualification(info) {
  return request({
    url: quanlification+'listData',
    method: 'post',
    params: info
  })
} */

/*
修改证书
bizDict	类型
classifyOne	一级分类
classifyThree	三级分类
classifyTwo	二级分类
idNumber  身份证号/或者营业执照
imageUrls 照片列表
mobile  手机号
title 资质名称/姓名
validDate 有效期
 */
/* export function quanlificationModify(info) {
  return request({
    url: quanlification+'modify',
    method: 'post',
    params: info
  })
} */
